import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import CompanyActions from '../actions/CompanyActions';


const CompanySource = {

    getCompany() {
        return {
            remote(state) {
                return new SingleObjectResource(DJ_CONST.API.myCompany).fetch();
            },

            success: CompanyActions.getCompanySuccess,
            error: CurrentUserActions.pageFault
        }
    },
};

class CompanyStore {
    constructor() {
        this.company = {};
        this.saveError = {};
        this.settingsSaved = false;
        this.companyDataReceived = false;
        this.exportAsync(CompanySource);
        this.bindActions(CompanyActions);
    }

    onClearCompanyData() {
        this.setState({company: {}, companyDataReceived: false});
    }

    onUpdateCompany() {
        this.setState({settingsSaved: true, saveError: {}});
        setTimeout(x => {this.setState({settingsSaved: false})}, 5000);
    }

    onGetCompanySuccess(company) {
        this.setState({company, companyDataReceived: true});
    }

    onFailUpdateCompany(errors) {
        this.setState({saveError: errors.updateError});
    }

    onMergeErrorsIntoState(errors) {
        this.setState({saveError: errors});
    }
}

export default createStore(CompanyStore, 'CompanyStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/CompanyStore.js
 **/